/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { templateSchema } from "../../utils/schemaUtils";
import {
  BODY_TYPES,
  EVENT_NAME,
  FOOTER_TYPES,
  HEADER_TYPES,
  ROUTES,
  SEARCH_PARAMS,
  HEADER,
  STORAGE_KEYS,
  FILE_UPLOAD_STATUS,
  API_ENDPOINTS,
  TARABUT_TPP_DETAILS,
  CONNECT_USER_DATA,
  BACK_TO_LOGIN_PATHS,
  FLEET_FINANCE_REQUIRED_DOCUMENTS,
  COUNTRY,
  EMI_CALCULATION_TYPE,
  LOAN_AMOUNT_TYPE,
  LINK_TEXT_ACTION,
} from "../../constants";
import {
  ChevronDown,
  ChevronUp,
  CircleCheck,
  Trophy,
  RedExclamationCircle,
} from "../../assets/svgs";
import api from "../../services";
import useApp from "../../hooks/useApp";
import {
  AnimatedSlider,
  BackButtonConfirmation,
  BottomContentModal,
  CustomLoader,
  ConfirmationPopup,
  DocumentListModal,
  PaymentPlanModal,
  TermsAndPrivacyModal,
  SelectBankModal,
  RemindMeLaterPopup,
} from "../../components";
import {
  findUrlAttribute,
  getInitials,
  parseDynamicArray,
  parseDynamicObject,
  mapAssetsGrouped,
  safeJsonParse,
  convertTimestamp,
} from "../../utils";
import useNavigateWithQuery from "../../hooks/useNavigateWithQuery";
import { logAnalyticEvent } from "../../analytics";
import "./styles.scss";
import {
  getSessionStorage,
  setSessionStorage,
  removeSessionStorage,
} from "../../utils/storageUtils";
import { isTokenExpired } from "../../utils/auth";
import { getExpiryStatus } from "../../utils/getExpiryStatus";
import { format } from "date-fns";
import { buildServerName, getServerFormat } from "../../utils/document";

const CompanyDetatils = () => {
  let interestRate = 0;
  let financeInsuranceRate = 0;
  let totalAssetCost = 0;
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;

  const routeName = pathname.split("/")[1];
  const taskIdRef = useRef(null);
  const hasRetried = useRef(false); // Place this at the top level of your component
  const lastUploadRef = useRef(new Map());
  const [searchParams, setSearchParams] = useSearchParams();
  const intentId = searchParams.get("intentId");
  const status = searchParams.get("status");

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [formState, setFormState] = useState([]);
  const [financeJourney, setFinanceJourney] = useState();
  const [showCountdownTimer, setShowCountdownTimer] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [eligibilityPolicy, setEligibilityPolicy] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [installment, setInallement] = useState(0);
  const [downpaymentAmount, setDownpaymentAmount] = useState(0);
  const [autoComplete, setAutoComplete] = useState(true);
  const [liabilityCheck, setLiabilityCheck] = useState(false);
  const [isHowItWorkVisible, setIsHowItWorkVisible] = useState(false);
  const [isLogoLoader, setIsLogoLoader] = useState(false);
  const [showBackConfirm, setShowBackConfirm] = useState(false);
  const [backNavigateTo, setBackNavigateTo] = useState("");
  const [direction, setDirection] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showRejectionPopup, setShowRejectionPopup] = useState(false);
  const [isButtonLoader, setIsButtonLoader] = useState(false);
  const [buttonType, setButtonType] = useState("default");
  const [bankUrl, setBankUrl] = useState(null);
  const [showDocumentListModal, setShowDocumentListModal] = useState(false);
  const [showPaymentPlanModal, setShowPaymentPlanModal] = useState(false);
  const [payments, setPayments] = useState([]);
  const [showTermsAndPrivacyModal, setShowTermsAndPrivacyModal] =
    useState(false);
  const [termsAndPrivacyData, setTermsAndPrivacyData] = useState(null);
  const [showSelectBankModal, setShowSelectBankModal] = useState(false);
  const [showRemindMeLater, setShowRemindMeLater] = useState(false);

  const activeUploadsRef = useRef(new Map());
  const [allRequiredUploaded, setAllRequiredUploaded] = useState(false);
  const uploadGroupStatusRef = useRef(new Map()); // Track status of each upload group
  const [uploadGroupCount, setUploadGroupCount] = useState(0);
  const [documentList, setDocumentList] = useState([]);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
  const [startTime, setStartTime] = useState(0);
  const [startJourneyTime, setStartJourneyTime] = useState(Date.now());
  const getLangDirection = () =>
    selectedLanguage?.direction === "rtl" ? -1 : 1;
  const navigateWithQuery = useNavigateWithQuery();
  const navigate = useNavigate();

  const {
    tenantConfig,
    isTCAccepted,
    handleIsTCAccepted,
    handleEligibilityData,
    financeJourneyStatus,
    handleFinanceJourneyStatus,
    userDetails,
    selectedLanguage,
    getUserDetails,
    handleSetProvider,
    handleFileSelect,
    uploadFiles,
    handleSetFileUploadStatus,
    fileUploadStatus,
    handleSetFileUploadProgress,
    handleAuthConnect,
    handleGetProviders,
    providers,
    loginUrl,
    channel,
    tenant,
    flow,
    product,
    customPath,
    nafathService,
    handleBackPreLogin,
    isRegexValid,
    selectedFinanceAssets,
  } = useApp();

  const connectAuth = getSessionStorage(STORAGE_KEYS.AUTH_CONNECT);
  const provider = getSessionStorage(STORAGE_KEYS.PROVIDER_DATA);

  const handleAnimationAxis = (slug) => {
    const verticalSlugs = [
      "auto-finance-apply-now",
      "auto-finance-track-request",
    ];
    const isVertical = verticalSlugs.includes(slug);
    return isVertical ? "y" : "x";
  };

  const handleNextJourney = async ({ hasLoader, autoComplete, status }) => {
    if (financeJourneyStatus?.id) {
      try {
        if (hasLoader) {
          setIsLoading(true);
        }
        const response = await api.getFinanceNextTask(financeJourneyStatus.id);
        const taskId = response.data?.page?.id;

        if (response.data.request.application_id) {
          setSessionStorage(
            HEADER.APPLICATION_ID,
            response.data.request.application_id
          );
        }
        setFinanceJourney(response.data);

        if (taskId && taskId !== taskIdRef.current) {
          taskIdRef.current = response.data.page.id || response.data.request.id;
          setIsLoading(false);
          setIsButtonLoader(false);

          setDirection(getLangDirection());
          setActiveIndex((prevState) => prevState + 1);
          if (showRejectionPopup) {
            setIsLogoLoader(false);
            setAutoComplete(true);
          }
          if (status === "FAILED" && !autoComplete && intentId) {
            setTimeout(() => {
              searchParams.delete("status");
              searchParams.delete("intentId");
              setSearchParams(searchParams);
            }, 1000);
          }
        }
      } catch (error) {
        console.error("Error in handleNextJourney api:", error);
      }
    }
  };

  const handleNextActionCall = async (action) => {
    if (action === "upload_document_next") {
      // Handle multiple file uploads
      const uploadedFiles = Object.entries(uploadFiles).filter(
        ([key, file]) => file !== null
      );

      for (const [fileKey, uploadFile] of uploadedFiles) {
        await api.uploadDocumentComplete({
          data: { status: "COMPLETE", file_url: uploadFile?.fileUrl },
          params: {
            applicationId:
              financeJourneyStatus.application_id ??
              financeJourney?.request?.application_id,
            documentId: uploadFile?.documentId,
          },
        });
      }
    }
  };

  const handleNextPress = async (action, variables = {}) => {
    const tenantName = getSessionStorage(SEARCH_PARAMS.TENANT);
    const product = getSessionStorage(HEADER.PRODUCT_SLUG);
    const channelId = getSessionStorage(HEADER.CHANNEL_ID);
    const flow = getSessionStorage(SEARCH_PARAMS.FLOW);

    const params = {
      requestId: financeJourney?.request?.id,
      taskId: financeJourney?.meta?.task?.id,
    };

    handleNextActionCall(action);

    setStartTime(Date.now());

    if (action === "nevigate_to_finance_detail") {
      try {
        setIsLoading(true);
        const response = await api.completeFinanceJourney({
          params,
          data: null,
        });
        const endTime = Date.now();
        logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
          path: `${window.location.origin}/${financeJourney?.page?.name}`,
          page_title: financeJourney?.page?.name,
          end_time: endTime,
          start_time: startTime,
          time_spent: convertTimestamp(endTime - startTime),
        });
        handleFinanceJourneyStatus();
      } catch (error) {
        console.error("Error in handleNextPress api:", error);
        setIsLoading(false);
      }
    } else if (action === "nevigate_to_dashboard") {
      await api.completeFinanceJourney({ params, data: null });
      const endTime = Date.now();
      logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
        path: `${window.location.origin}/${financeJourney?.page?.name}`,
        page_title: financeJourney?.page?.name,
        end_time: endTime,
        start_time: startTime,
        time_spent: convertTimestamp(endTime - startTime),
      });
      setIsLoading(false);
      setDirection(getLangDirection());
      navigateWithQuery(`/${ROUTES.MERCHANT_SUPPORT}`);
    } else {
      try {
        let response = null;
        if (
          action === "continue_to_link_bank" ||
          financeJourney.page.slug === "auto-finance-link-bank-account" ||
          financeJourney.page.slug === "stp-pos-finance-link-bank-account" ||
          financeJourney.page.slug === "fleet-finance-link-bank-account"
        ) {
          setIsLogoLoader(true);
        } else {
          setIsLoading(true);
        }
        if (
          (financeJourney.page.slug === "stp-pos-finance-link-bank-account" ||
            financeJourney.page.slug === "fleet-finance-link-bank-account") &&
          intentId &&
          status === "FAILED"
        ) {
          setAutoComplete(false);
          setIsLogoLoader(false);
          setShowRejectionPopup(true);
          return;
        }

        let data = {
          variables: {
            ...formState,
            redirect_url: `${window.location.origin}/${
              window.location.pathname.split("/")[1]
            }?${SEARCH_PARAMS.TENANT}=${tenantName}&${
              SEARCH_PARAMS.PRODUCT
            }=${product}&${SEARCH_PARAMS.CHANNEL_ID}=${channelId}&${
              SEARCH_PARAMS.FLOW
            }=${flow}`,
            providerId: provider?.providerId,
            noPendingLiabilities: liabilityCheck,
            doc_simah_report: uploadFiles?.default?.fileName, // For backward compatibility,
            intentId: intentId ? intentId : "",
            status: !status ? "" : status,
            installment: installment ? installment : "",
            in_emi: installment ? installment : "",
            selected_assets: selectedFinanceAssets,
            ...variables,
          },
        };

        if (action === "add_new_bank") {
          setIsLogoLoader(false);
          data.variables["add_new_bank"] = true;
        }
        if (action === "exit_application_without_complete") {
          const endTime = Date.now();
          removeSessionStorage(HEADER.USER_ID);
          removeSessionStorage(HEADER.APPLICATION_ID);
          removeSessionStorage(STORAGE_KEYS.AUTH_CONNECT);
          handleBackPreLogin();
          navigate(`/`);
          logAnalyticEvent(EVENT_NAME.COMPLETE_DISTRIBUTOR_JOURNEY, {
            end_time: endTime,
            start_time: startJourneyTime,
            time_spent: convertTimestamp(endTime - startJourneyTime),
          });
        } else {
          response = await api.completeFinanceJourney({ params, data });
          const endTime = Date.now();
          logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
            path: `${window.location.origin}/${financeJourney?.page?.name}`,
            page_title: financeJourney?.page?.name,
            end_time: endTime,
            start_time: startTime,
            time_spent: convertTimestamp(endTime - startTime),
          });
        }
        if (action === "add_new_bank") {
          navigate(`/${ROUTES.COMPANY_DETAILS}`, { replace: true });
        }

        if (action === "exit_application") {
          const endTime = Date.now();
          removeSessionStorage(HEADER.USER_ID);
          removeSessionStorage(HEADER.APPLICATION_ID);
          removeSessionStorage(STORAGE_KEYS.AUTH_CONNECT);
          handleBackPreLogin();
          navigate(`/`);
          logAnalyticEvent(EVENT_NAME.COMPLETE_FINANCE_JOURNEY, {
            end_time: endTime,
            start_time: startJourneyTime,
            time_spent: convertTimestamp(endTime - startJourneyTime),
          });
        }
        if (response?.message === "TASK_COMPLETED") {
          setTimeout(() => {
            if (financeJourney.page.slug === "company-registartion-task") {
              setIsLoading(false);
            }
          }, 60000);
          taskIdRef.current = financeJourney.page.id;
          hasRetried.current = false;
          setFormState([]);
          setFinanceJourney(null);
          handleNextJourney({ hasLoader: true });
        }
        setShowRemindMeLater(false);
      } catch (error) {
        const errorType = error?.response?.data?.name;
        if (
          (errorType === "TASK_COMPLETION_FAILED" ||
            errorType === "TASK_NOT_FOUND") &&
          !hasRetried.current
        ) {
          hasRetried.current = true;
          setTimeout(async () => {
            await handleNextPress(action);
          }, 500);
        }

        console.error("Error in handleNextPress api:", error);
        setIsLoading(false);
        setIsLogoLoader(false);
      }
    }
  };

  const handleBackPress = async () => {
    const params = {
      requestId: financeJourney?.request?.id,
      taskId: financeJourney?.meta?.task?.id,
    };
    try {
      setIsLoading(true);
      setIsButtonLoader(false);
      await api.backFinanceJourney({ params });
      handleFinanceJourneyStatus();
    } catch (error) {
      console.error("Error in handleBackPress api:", error);
      setIsLoading(false);
    }
  };

  const handleCreateIntent = async () => {
    const payload = {
      ...CONNECT_USER_DATA,
      providerId: provider?.providerId,
      consent: {
        ...(CONNECT_USER_DATA?.consent || {}),
        providerId: provider?.providerId,
        tppDetails: TARABUT_TPP_DETAILS,
      },
      user: {
        customerUserId: `${userDetails.id}`,
        firstName: userDetails?.first_name
          ? userDetails.first_name[selectedLanguage.value]
          : "test",
        lastName: userDetails?.last_name
          ? userDetails.last_name[selectedLanguage.value]
          : "user",
      },
      language: selectedLanguage.value,
      redirectUrl: `${window.location.origin}/company-details`,
    };
    try {
      const response = await axios.post(
        API_ENDPOINTS.CREATE_INTENT(connectAuth?.base_url),
        payload,
        {
          headers: {
            Authorization: `Bearer ${connectAuth?.accessToken}`,
          },
        }
      );
      setBankUrl(response.data?.connectUrl);
    } catch (error) {
      console.error("Create Intent API Error:", error);
    }
  };

  const onClickBackConfirm = () => {
    if (
      financeJourney?.page?.slug === "stp-pos-finance-bank-connected" ||
      financeJourney?.page?.slug === "fleet-finance-bank-connected"
    ) {
      searchParams.delete("status");
      searchParams.delete("intentId");
      setSearchParams(searchParams);
      handleBackPress();
      setShowBackConfirm(false);
    } else {
      setShowBackConfirm(false);
      removeSessionStorage(HEADER.AUTHORIZATION);
      removeSessionStorage(HEADER.REFRESH_TOKEN);
      removeSessionStorage(HEADER.USER_ID);
      removeSessionStorage(HEADER.APPLICATION_ID);
      removeSessionStorage(STORAGE_KEYS.AUTH_CONNECT);
      navigateWithQuery(`/${backNavigateTo}`);
    }
  };

  const isValidNumber = () => {
    const countryCode = selectedCountry?.country_code || "";
    const number = `${countryCode}${formState?.phoneNo || ""}`;
    if (selectedCountry?.custom_regex) {
      return !!number.match(selectedCountry.custom_regex);
    }
    return false;
  };

  const handleOnChange = (event) => {
    const { value } = event.target;
    setFormState({
      phoneNo: value,
    });
    // setIsButtonEnabled(value.length > 0);
    // setErrorMessage("");
  };

  const handleOnBlur = () => {
    const isValid = isValidNumber();
    if (!isValid) {
      // setErrorMessage(selectedCountry?.message[selectedLanguage?.value]);
    }
  };
  const calculateStraightLineInstallment = () => {
    const assetCostWithVAT = Number(formState.leasing_amount);
    const downPaymentPercent = Number(formState.downpayment_percent);
    const tenorMonths = Number(formState.loan_duration);
    const annualProfitRate = Number(interestRate) / 100;
    const downpaymentAmount = assetCostWithVAT * (downPaymentPercent / 100);
    const netFinancingAmount = assetCostWithVAT - downpaymentAmount;
    const totalProfit =
      netFinancingAmount * (annualProfitRate * (tenorMonths / 12));
    // const totalInsurance =
    //   Number(financeInsuranceRate) *
    //   Number(totalAssetCost) *
    //   (tenorMonths / 12);
    const totalPayable = netFinancingAmount + totalProfit; //+ totalInsurance;
    const installment = totalPayable / tenorMonths;

    setDownpaymentAmount(downpaymentAmount.toFixed(3));
    setInallement(installment.toFixed(3));
  };

  const calculateInstallment = () => {
    const annualRate = interestRate;
    const monthlyRate = annualRate / 100 / 12;
    const loanDuration = Number(formState.loan_duration || formState.in_tenure);

    let loanAmount = 0;
    let downpaymentAmount = 0;

    // CASE 1: Downpayment as amount (direct loan amount or downpayment_amount)
    if (formState.downpayment_amount || formState.loan_amount) {
      loanAmount = Number(
        formState.downpayment_amount || formState.loan_amount
      );
    }

    // CASE 2: Downpayment as percentage (leasing_amount + percent)
    if (formState.downpayment_percent && formState.leasing_amount) {
      const leasingAmount = Number(formState.leasing_amount);
      const downPercent = Number(formState.downpayment_percent);

      downpaymentAmount = (downPercent / 100) * leasingAmount;
      loanAmount = leasingAmount - downpaymentAmount;

      setDownpaymentAmount(downpaymentAmount.toFixed(3));
    }

    // EMI formula
    const emi =
      (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanDuration)) /
      (Math.pow(1 + monthlyRate, loanDuration) - 1);

    if (isNaN(emi) || !isFinite(emi)) {
      setInallement(0);
      return;
    }

    setInallement(emi.toFixed(3));
  };

  function base64ToBlob(base64, contentType = "") {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  const loadDocumentList = useCallback(async () => {
    const applicationId =
      financeJourneyStatus?.application_id ||
      financeJourney?.request?.application_id;

    if (!applicationId) return;

    try {
      setIsLoadingDocuments(true);
      const response = await api.getDocumentList({ applicationId });
      setDocumentList(response.data || []);
    } catch (error) {
      console.error("Error loading document list:", error);
    } finally {
      setIsLoadingDocuments(false);
    }
  }, [
    financeJourneyStatus?.application_id,
    financeJourney?.request?.application_id,
  ]);

  // Function to delete a document
  const handleDeleteDocument = useCallback(
    async (documentId) => {
      const applicationId =
        financeJourneyStatus?.application_id ||
        financeJourney?.request?.application_id;

      if (!applicationId || !documentId) return;

      try {
        await api.deleteDocument({ applicationId, documentId });

        // Update local document list
        setDocumentList((prev) => prev.filter((doc) => doc.id !== documentId));

        // Also update file upload status
        // Find the fileKey for this document
        const deletedDoc = documentList.find((doc) => doc.id === documentId);
        if (deletedDoc) {
          // You'll need to map document_type to your fileKey format
          // This depends on how you name your files
          const fileKey = `default-${deletedDoc.document_type.toLowerCase()}`;
          handleSetFileUploadStatus(fileKey, FILE_UPLOAD_STATUS.NOT_STARTED);
          handleSetFileUploadProgress(fileKey, 0);
        }

        return true;
      } catch (error) {
        console.error("Error deleting document:", error);
        return false;
      }
    },
    [
      documentList,
      financeJourneyStatus?.application_id,
      financeJourney?.request?.application_id,
    ]
  );

  const handleFileUpload = async (fileData, fileKey = "default", meta = {}) => {
    if (!fileData || !fileData.file) return;

    if (activeUploadsRef.current.has(fileKey)) return;

    const f = fileData.file;
    const signature = `${f.name}-${f.size}-${f.lastModified}`;

    const prev = lastUploadRef.current.get(fileKey);
    const now = Date.now();
    if (prev && prev.signature === signature && now - prev.time < 2000) return;

    lastUploadRef.current.set(fileKey, { signature, time: now });

    activeUploadsRef.current.set(fileKey, true);

    const payload = {
      name: buildServerName({
        originalFileName: fileData.file?.name,
        groupKey: meta?.group_key,
        slotIndex: meta?.slot_index,
        providerId: meta?.provider_id,
      }),
      format: getServerFormat(fileData.file),
      document_type: fileData.type,
      size: fileData.file?.size,
    };

    try {
      handleSetFileUploadStatus(fileKey, FILE_UPLOAD_STATUS.IN_PROGRESS);
      handleSetFileUploadProgress(fileKey, 10);

      const docUrlResponse = await api.generateUploadUrl({
        payload,
        applicationId:
          financeJourneyStatus.application_id ??
          financeJourney?.request?.application_id,
      });

      handleSetFileUploadProgress(fileKey, 30);

      const binaryFile = base64ToBlob(fileData.base64, fileData.type);
      const fileUrl = docUrlResponse?.data?.file_url;
      const documentId = docUrlResponse?.data?.id;

      if (!fileUrl || !documentId) {
        throw new Error("Missing file URL or document ID from response.");
      }

      await api.uploadFile({
        url: fileUrl,
        file: binaryFile,
        onUploadProgress: (event) => {
          const percent = Math.round((event.loaded * 100) / event.total);
          handleSetFileUploadProgress(fileKey, percent < 95 ? percent : 95);
        },
      });

      await api.uploadDocumentComplete({
        data: { status: "COMPLETE", file_url: fileUrl },
        params: {
          applicationId:
            financeJourneyStatus.application_id ??
            financeJourney?.request?.application_id,
          documentId,
        },
      });

      handleSetFileUploadProgress(fileKey, 98);

      handleFileSelect(fileKey, {
        fileUrl,
        documentId,
        fileName: fileData.file?.name,
      });

      handleSetFileUploadProgress(fileKey, 100);
      handleSetFileUploadStatus(fileKey, FILE_UPLOAD_STATUS.COMPLETED);

      loadDocumentList();
    } catch (error) {
      console.error(`Upload failed for ${fileKey}:`, error);
      handleSetFileUploadProgress(fileKey, 0);
      handleSetFileUploadStatus(fileKey, FILE_UPLOAD_STATUS.FAILED);
    } finally {
      activeUploadsRef.current.delete(fileKey);
    }
  };

  const handleAllRequiredUploaded = (status) => {
    setAllRequiredUploaded(status);
  };

  // Function to update group status
  const updateUploadGroupStatus = useCallback((groupId, status) => {
    uploadGroupStatusRef.current.set(groupId, status);
    checkAllGroupsUploaded();
  }, []);

  // Check if ALL groups have uploaded their required documents
  const checkAllGroupsUploaded = useCallback(() => {
    const groups = Array.from(uploadGroupStatusRef.current.values());

    // If there are no groups with required documents, return true
    if (groups.length === 0) {
      setAllRequiredUploaded(true);
      return;
    }

    // Check if ALL groups report that all their required documents are uploaded
    const allUploaded = groups.every((group) => group === true);
    setTimeout(() => {
      setAllRequiredUploaded(allUploaded);
    }, 500);
  }, []);

  // Extract all required documents from schema
  const extractRequiredDocuments = useCallback((components) => {
    let count = 0;

    const traverseComponents = (comps) => {
      if (!Array.isArray(comps)) return;

      comps.forEach((component) => {
        // Check for document upload cards
        if (component.attributes?.type === BODY_TYPES.DOCUMENT_UPLOAD_CARD) {
          const documents = component.attributes?.documents
            ? JSON.parse(component.attributes.documents)
            : [];

          const hasRequired = documents.some((doc) => doc.isRequired);
          if (hasRequired) {
            count++;
          }
        }

        // Check for tab bars with documents
        if (component.attributes?.type === BODY_TYPES.TAB_BAR) {
          const tabData = component.attributes?.tabData
            ? JSON.parse(component.attributes?.tabData)
            : [];
          const hasRequiredInTabs = tabData?.value.some(
            (tab) =>
              tab.tabType === "document" &&
              (tab.documentCount > 0 || tab.tabData?.[0]?.isRequired)
          );
          if (hasRequiredInTabs) {
            count++;
          }
        }

        // Recursively check nested components
        if (component.components) {
          traverseComponents(component.components);
        }
      });
    };

    traverseComponents(components);
    return count;
  }, []);

  // Load document list when application ID is available
  useEffect(() => {
    if (
      financeJourneyStatus?.application_id ||
      financeJourney?.request?.application_id
    ) {
      loadDocumentList();
    }
  }, [
    financeJourneyStatus?.application_id,
    financeJourney?.request?.application_id,
    loadDocumentList,
  ]);

  // Initialize upload group count when schema loads
  useEffect(() => {
    if (financeJourney?.page?.content?.components) {
      const count = extractRequiredDocuments(
        financeJourney.page.content.components
      );
      setUploadGroupCount(count);
    }
  }, [financeJourney?.page?.content, extractRequiredDocuments]);

  const handleDefaultHeaderRightClick = () => {
    setIsHowItWorkVisible(true);
  };

  const handleDefaultBtnDisabled = (action) => {
    const allowedActions = [
      "continue_link_bank",
      "upload_document_next",
      "submit_liability_request",
      "continue_to_link_bank",
      "submit_document",
      "submit_vat",
      "submit_fleet_finance_asset",
      "submit_call_time",
      "about_your_business",
      "accept_terms_and_condition",
    ];

    if (allowedActions.includes(action)) {
      if (action === "continue_link_bank" && provider) {
        return false;
      } else if (action === "submit_liability_request" && liabilityCheck) {
        return false;
      } else if (action === "continue_to_link_bank" && !isLogoLoader) {
        return false;
      } else if (action === "submit_document") {
        // Check if any files are uploaded
        return !allRequiredUploaded;
      } else if (
        action === "submit_vat" &&
        formState?.vat_number &&
        isRegexValid.length === 0
      ) {
        return false;
      } else if (selectedFinanceAssets.length > 0) {
        //Check fleet finance asset selection
        return false;
      } else if (action === "submit_call_time" && formState?.in_call_time) {
        return false;
      } else if (
        action === "about_your_business" &&
        formState?.in_application_role &&
        formState?.in_is_qoutation_available &&
        formState?.in_cr_number &&
        formState?.in_company_name &&
        isRegexValid.length === 0
      ) {
        return false;
      } else if (action === "accept_terms_and_condition" && isTCAccepted) {
        return false;
      } else {
        return true;
      }
    } else if (!financeJourney?.meta?.task?.id) {
      return true;
    } else {
      return false;
    }
  };

  const getInfoCardValue = (value) => {
    if (
      !value ||
      (typeof value === "string" && !value.trim()) ||
      value === "null"
    ) {
      return "--";
    }
    if (typeof value === "object") {
      return value[selectedLanguage?.value] ?? "--";
    }
    if (typeof value === "string") {
      if (value.includes(COUNTRY.SAUDI_ARABIA.CURRENCY_CODE)) {
        const numericString = value.replace(/[^\d.-]/g, "");
        const numericValue = parseFloat(numericString);
        return isNaN(numericValue) ? (
          value
        ) : (
          <div className="saudi-riyal-wrapper">
            <span className="icon-saudi_riyal"></span>
            <span>{numericValue.toLocaleString()}</span>
          </div>
        );
      }
    }
    return value;
  };

  const handleCardContent = (props) => {
    switch (props?.cardType) {
      case "success_card":
        return (
          <div className="success-card-content">
            <img
              src={CircleCheck}
              alt="success icon"
              className="success-card-icon"
            />
            <h2 className="success-card-heading">
              {t(`${routeName}.${props?.cardHeading}`)}
            </h2>
            <p className="success-card-description">
              {t(`${routeName}.${props?.cardDescription}`)}
            </p>
          </div>
        );
      case "number_card":
        return (
          <div className="waitlist-card">
            <div className="icon-label-container">
              <img src={Trophy} alt="icon" className="trophy-icon" />
              <span className="waitlist-text">Your position in waitlist</span>
            </div>
            <h2 className="position-number">{`#${financeJourneyStatus?.application_id}`}</h2>
            <p className="referral-note">
              Refer friends to move up in the waitlist
            </p>
          </div>
        );
      case "value_slider_card":
        return (
          <div className="financial-profile-card">
            <p className="section-title">Based on your financial profile:</p>
            <h2 className="amount">SAR 320,000</h2>
            <p className="subtext">
              Maximum auto financing amount you can afford
            </p>

            <div className="progress-bar">
              <div className="progress-fill" />
              <span className="progress-label">Excellent</span>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const getCustomProps = (props, index) => {
    switch (props.type) {
      // Header Types
      case HEADER_TYPES.DASHBOARD_HEADER: {
        let sanitizedString;
        if (props?.value) {
          sanitizedString = JSON.parse(props?.value);
        }
        return {
          welcomBackHeading: `${t(`${routeName}.hello`)} ${
            userDetails?.first_name
              ? userDetails?.first_name[selectedLanguage?.value]
              : ""
          }`,
          usersInitials:
            userDetails?.full_name &&
            getInitials(userDetails?.full_name[selectedLanguage?.value]),
          loanLabelText: t(`${routeName}.${props?.loanLabelText}`),
          loanAmountText: props?.value ? sanitizedString.value : "",
          onClick: () => navigateWithQuery(`/${ROUTES.SETTINGS}`),
        };
      }
      case HEADER_TYPES.STEPPER: {
        return {
          onClick: () => handleBackPress(),
        };
      }
      case HEADER_TYPES.DEFAULT_HEADER: {
        return {
          containerStyle:
            financeJourney?.page?.slug ===
            "enter-link-account-phone-number-task"
              ? "default-header-container"
              : "",
          onClickRightIcon: () => handleDefaultHeaderRightClick(),
          onClick: () => {
            if (props?.showBackConfirm) {
              setBackNavigateTo(props?.navigateTo);
              setShowBackConfirm(true);
            } else {
              if (props?.navigateTo === "keycloak") {
                removeSessionStorage(HEADER.AUTHORIZATION);
                removeSessionStorage(HEADER.REFRESH_TOKEN);
                removeSessionStorage(HEADER.USER_ID);
                removeSessionStorage(HEADER.APPLICATION_ID);
                removeSessionStorage(STORAGE_KEYS.AUTH_CONNECT);
                const state = encodeURIComponent(
                  `${SEARCH_PARAMS.TENANT}=${tenant}&${
                    SEARCH_PARAMS.PRODUCT
                  }=${product}&${
                    SEARCH_PARAMS.CHANNEL_ID
                  }=${channel}&ui_locales=${selectedLanguage?.value}&${
                    SEARCH_PARAMS.FLOW
                  }=${flow}&${SEARCH_PARAMS.NAFATH_SERVICE}=${nafathService}&${
                    SEARCH_PARAMS.APP_URL
                  }=${`${window.location.origin}/app/${customPath}/${BACK_TO_LOGIN_PATHS.BACK_PRE_LOGIN}`}`
                );
                const finalUrl = `${loginUrl}&ui_locales=${selectedLanguage?.value}&state=${state}`;
                if (loginUrl) window.location.href = finalUrl;
              } else {
                handleBackPress();
              }
            }
          },
        };
      }

      // Body Types
      // Used only to set initial form state
      case BODY_TYPES.INITIAL_FORM_STATE: {
        const {
          calculationType,
          loanAmountType,
          minFinancingAmount,
          financeRate,
          insuranceRate,
          assetCost,
        } = props?.data || {};
        if (
          calculationType === EMI_CALCULATION_TYPE.REDUCING_BALANCE &&
          loanAmountType === LOAN_AMOUNT_TYPE.MIN_FINANCING_AMOUNT &&
          !("loan_amount" in formState)
        ) {
          setFormState((prevState) => ({
            ...prevState,
            loan_amount: Number(minFinancingAmount) || 0,
          }));
        }
        if (financeRate || insuranceRate || assetCost) {
          interestRate = financeRate ? financeRate : 0;
          financeInsuranceRate = insuranceRate ? insuranceRate : 0;
          totalAssetCost = assetCost ? assetCost : 0;
        }
      }
      case BODY_TYPES.FORM:
        return {
          setFormState: setFormState,
          formState: formState,
        };
      case BODY_TYPES.COLLAPSIBLE_INFO: {
        return {
          openedIcon: ChevronUp,
          closedIcon: ChevronDown,
          open: Boolean(props?.open),
          headingClass: "collapsible-info-heading",
          cardHeading: t(`${routeName}.${props?.heading}`),
          collapsibleWrapperClassOpen: "custom-collapsible-info-container-open",
          collapsibleWrapperClassClose:
            "custom-collapsible-info-container-close",

          collapsibleCildren: (
            <>
              <p className="collapsible-info-description">
                {t(`${routeName}.${props?.description}`)}
              </p>
            </>
          ),
        };
      }
      case BODY_TYPES.INFO_CARD: {
        const { cardData, isCustomData } = props;
        let parseData = [];

        if (cardData) {
          if (isCustomData) {
            const parsedArray = parseDynamicArray(cardData) || [];

            interestRate = parsedArray[1]?.value || 0;
            parseData = [
              {
                label: parsedArray[0]?.label || "",
                value: `${installment} ${COUNTRY.SAUDI_ARABIA.CURRENCY_CODE}`,
              },
              {
                label: parsedArray[1]?.label || "",
                value: `${parsedArray[1]?.value || 0}%`,
              },
              {
                label: parsedArray[2]?.label || "",
                value: `${parsedArray[2]?.value || 0}`,
                // ${
                //   COUNTRY.SAUDI_ARABIA.CURRENCY_CODE
                // }
              },
              parsedArray[3]?.label && {
                label: parsedArray[3]?.label || "",
                value: `${formState?.downpayment_amount || downpaymentAmount} ${
                  COUNTRY.SAUDI_ARABIA.CURRENCY_CODE
                }`,
              },
            ];
          } else {
            parseData = safeJsonParse(props?.cardData, null);
          }
        }

        return {
          openedIcon: ChevronUp,
          closedIcon: ChevronDown,
          open: Boolean(props?.open),
          headingClass: "container-heaing",
          cardHeading: props?.heading
            ? t(`${routeName}.${props?.heading}`)
            : null,
          installment,
          collapsibleCildren: cardData ? (
            <>
              {parseData
                ?.filter(
                  (item) => item && !props.hiddenValues?.includes(item.value)
                )
                ?.map((item) => {
                  const value = getInfoCardValue(item.value);
                  return (
                    <div className={`bd-item-container`}>
                      <span className={`bd-item-label`}>
                        {t(`${routeName}.${item.label}`)}
                      </span>
                      <div className="bd-item-value-container">
                        {item.badge && value !== "--" ? (
                          <div className="bd-item-badge" />
                        ) : null}
                        <p className={`bd-item-value`}>{value}</p>
                      </div>
                    </div>
                  );
                })}
            </>
          ) : (
            <></>
          ),
        };
      }
      case BODY_TYPES.CONTENT_HEADING: {
        return {
          heading: t(`${routeName}.${props.heading}`, {
            tenant: tenantConfig?.name,
          }),
        };
      }
      case BODY_TYPES.OTP_INPUT:
        return {
          setCode: (code) => setFormState({ code }),
          code: formState?.code ?? "",
          otpNotRecieve: t(`${routeName}.${props?.otpNotRecieve}`),
          resendCode: t(`${routeName}.${props?.resendCode}`),
          resend: t(`${routeName}.${props?.resend}`),
          otpLength: props?.otpLength,
        };
      case BODY_TYPES.PHONE_NUMBER_INPUT:
        return {
          countryCode: selectedCountry?.country_code,
          value: formState?.phoneNo,
          onChange: handleOnChange,
          onBlur: handleOnBlur,
          maxLength: selectedCountry?.phone_number_length,
          isoCode: selectedCountry?.iso_cod,
        };
      case BODY_TYPES.PROGRESS_CIRCLE_CHART:
        return {
          chartText: "Almost There",
        };
      case BODY_TYPES.DETAIL_CARD: {
        let parseData = [];
        const { cardData, isCustomData, heading } = props;

        if (cardData) {
          if (isCustomData) {
            const parsedArray = parseDynamicArray(cardData) || [];

            interestRate = parsedArray[1]?.value || 0;
            parseData = [
              {
                label: parsedArray[0]?.label || "",
                value: `${installment} ${COUNTRY.SAUDI_ARABIA.CURRENCY_CODE}`,
              },
              {
                label: parsedArray[1]?.label || "",
                value: `${parsedArray[1]?.value || 0}%`,
              },
              {
                label: parsedArray[2]?.label || "",
                value: `${parsedArray[2]?.value || 0} ${
                  COUNTRY.SAUDI_ARABIA.CURRENCY_CODE
                }`,
              },
            ];
          } else {
            parseData = parseDynamicArray(cardData) || [];
          }
        }

        return {
          data: cardData ? parseData : [],
          heading: heading ? t(`${routeName}.${heading}`) : null,
          itemValueStyle: "bd-item-value",
          noLastItemContainerStyle: "no-bd-info-container",
          installment,
        };
      }
      case BODY_TYPES.ELIGIBILITY_CARDS:
        return {
          activeTabIndex: activeTabIndex,
        };
      case BODY_TYPES.STEP_CARD: {
        return {
          cardDescription: t(`${routeName}.${props?.cardDescription}`, {
            tenant: tenantConfig?.name,
          }),
          cardHeading: t(`${routeName}.${props?.cardHeading}`, {
            tenant: tenantConfig?.name,
          }),
        };
      }
      case BODY_TYPES.ONBOARDING_CARD: {
        return {
          type: props?.type,
          cardBackgroundImage: props?.cardBackgroundImage,
          cardDescription: t(`${routeName}.${props?.cardDescription}`),
          cardHeading: t(`${routeName}.${props?.cardHeading}`),
        };
      }
      case BODY_TYPES.SLIDER_CARD: {
        const maxValue = props.maxValue
          ? parseDynamicObject(props.maxValue)
          : 0;
        const minValue = props.maxValue
          ? parseDynamicObject(props.minValue)
          : 0;
        const initialValue = parseDynamicObject(
          props.initialValue ? props.initialValue : props.maxValue
        );
        const rightLabelData = props?.rightLabelData
          ? JSON.parse(props?.rightLabelData)
          : null;
        if (!formState[props?.key]) {
          setFormState((prevState) => ({
            ...prevState,
            [props?.key]: initialValue.value ? initialValue.value : 100,
          }));
        }

        const rawValue = Number(formState[props?.key] ?? maxValue?.value ?? 0);
        const value = props.isCustomValue
          ? Math.max(0, rawValue - downpaymentAmount)
          : rawValue;

        return {
          onChange: (value) => {
            setFormState((prevState) => ({
              ...prevState,
              [props?.key]: value,
            }));
          },
          maxValue: maxValue?.value ? maxValue?.value : 100,
          minValue: minValue?.value ? minValue?.value : 0,
          keyType: props?.key,
          value: value,
          step: props?.step ? props?.step : 1,
          disabled: maxValue?.value == minValue?.value,
          rightLabelData: rightLabelData,
          calculatedValue: downpaymentAmount,
          customValue: installment,
        };
      }
      case BODY_TYPES.LOAN_DISBURSEMENT_CARD: {
        const parsedArray = props?.cardData
          ? parseDynamicArray(props?.cardData)
          : null;
        const maxVal = parseDynamicObject(props.maxValue);
        const minVal = parseDynamicObject(props.minValue);

        return {
          onChange: () => {},
          disbursementHeading: t(`${routeName}.${props?.heading}`),
          disbursementDescription: t(`${routeName}.${props?.discription}`),
          valueSuffix: "value_suffix_saudi",
          labelSuffix: "value_suffix_saudi",
          minValue: minVal?.value ? minVal?.value : 0,
          maxValue: maxVal?.value ? maxVal?.value : 10,
          cardData: parsedArray,
        };
      }
      case BODY_TYPES.LOAN_DETAILS_CARD: {
        const cardData = parseDynamicArray(props.cardData);
        return {
          loanDescription: t(`${routeName}.${props?.loanDescription}`),
          loanHeading: t(`${routeName}.${props?.loanHeading}`),
          detailCardHeading: t(`${routeName}.${props?.detailCardHeading}`),
          cardData: cardData,
        };
      }
      case BODY_TYPES.LOAN_PROGRESS_CARD: {
        return {
          stepHeading: t(`${routeName}.${props?.stepHeading}`),
        };
      }
      case BODY_TYPES.IMAGE: {
        const image = props.image;

        return {
          image:
            financeJourney?.page?.slug ===
            "enter-link-account-phone-number-task"
              ? `data:image/png;base64,${tenantConfig?.favicon.content.dark}`
              : image,
          styles:
            financeJourney?.page?.slug ===
            "enter-link-account-phone-number-task"
              ? {
                  ...props?.styles,
                  width: "70px",
                  height: "70px",
                  marginLeft: "24px",
                  marginRight: "24px",
                  objectFit: "contain",
                }
              : props?.styles,
        };
      }
      case BODY_TYPES.QUEUE_CARD: {
        const cardValue = parseDynamicObject(props?.cardValue);

        return {
          cardValue: cardValue?.value,
        };
      }
      case BODY_TYPES.BANK_SELECT_CARD: {
        const parseData = props?.data ? JSON.parse(props?.data) : [];
        return {
          data: providers.length ? providers : parseData,
          onSelect: (item) => {
            handleSetProvider(item);
            handleNextPress("", {
              providerId: item?.providerId,
              aisStatus: item?.aisStatus,
            });
          },
        };
      }
      case BODY_TYPES.CUSTOM_CONNECT_CARD: {
        const parseData = JSON.parse(props?.connectUrl);
        return {
          cardDescription: t(`${routeName}.${props?.cardDescription}`),
          buttonText: t(`${routeName}.${props?.buttonText}`),
          cardImage: provider?.logoUrl,
          connectUrl: parseData?.value,
          loading: intentId,
          loadingText: t(`${routeName}.connect_your_bank`),
          onConnect: () => {},
        };
      }
      case BODY_TYPES.CUSTOM_CONTENT_CARD: {
        return {
          cardContent: handleCardContent(props),
        };
      }
      case BODY_TYPES.BULLET_CARD: {
        return {
          heading: t(`${routeName}.${props?.heading}`),
          bulletPoints: JSON.parse(props?.bulletPoints),
        };
      }
      case BODY_TYPES.UPLOAD_CARD: {
        return {
          onFileUpload: handleFileUpload,
          onAllRequiredUploaded: handleAllRequiredUploaded,
        };
      }
      case BODY_TYPES.REQUEST_ID_CARD: {
        return {
          type: BODY_TYPES.REQUEST_ID_CARD,
          title: t(`${routeName}.${props?.title}`, {
            applicationId:
              financeJourneyStatus?.application_id ??
              financeJourney?.request?.application_id,
          }),
          description: t(`${routeName}.${props?.description}`),
        };
      }
      case BODY_TYPES.POWERED_BY: {
        return {
          type: BODY_TYPES.POWERED_BY,
          poweredByText: t(`${routeName}.${props?.title}`),
          footerText: props?.footerText
            ? t(`${routeName}.${props?.footerText}`)
            : null,
        };
      }
      case BODY_TYPES.UPLOAD_SUCCESS_CARD: {
        const parseData = JSON.parse(props?.documentName);
        return {
          title: t(`${routeName}.${props?.title}`),
          description: t(`${routeName}.${props?.description}`),
          documentName: parseData?.value,
        };
      }
      case BODY_TYPES.CONNECT_BANK_CARD: {
        const parseData = props?.cardData ? JSON.parse(props?.cardData) : [];

        const bankRowClassName = props?.topButtonText
          ? "bank-row-border-bottom"
          : "bank-row-border-top";
        let providerName = provider
          ? provider?.displayName
          : getSessionStorage(STORAGE_KEYS.PROVIDER_DATA)?.displayName;

        if (selectedLanguage.value === "ar") {
          providerName = provider
            ? provider?.arabicDisplayName
            : getSessionStorage(STORAGE_KEYS.PROVIDER_DATA)?.arabicDisplayName;
        }
        return {
          heading: t(`${routeName}.${props?.heading}`),
          description: t(`${routeName}.${props?.description}`, {
            providerName,
          }),
          dataRowText: t(`${routeName}.${props?.dataRowText}`, {
            bankCount: props?.showCount
              ? providers?.length > 6
                ? `+${providers?.length || parseData.length}`
                : providers?.length || parseData.length
              : "",
          }),
          topButtonText: props?.topButtonText
            ? t(`${routeName}.${props?.topButtonText}`)
            : null,
          buttonText: t(`${routeName}.${props?.buttonText}`),
          disabled:
            (isLoading && isButtonLoader) || !financeJourney?.meta?.task?.id,
          onBtnClick: () =>
            financeJourney?.meta?.task?.id && handleNextPress(props.action),
          cardData: parseData ? parseData : providers,
          bankRowClassName: bankRowClassName,
          isLoading: isLoading && isButtonLoader,
        };
      }
      case BODY_TYPES.STATUS_INFO_CARD: {
        return {
          statusText: t(`${routeName}.${props?.statusText}`),
          statusTime: props?.statusTime
            ? t(`${routeName}.${props?.statusTime}`)
            : "",
          dotColor: props?.dotColor,
        };
      }
      case BODY_TYPES.DATA_LABEL_CARD: {
        const today = format(new Date(), "dd MMM, yyyy");
        const tomorrow = format(
          new Date(Date.now() + 24 * 60 * 60 * 1000),
          "dd MMM, yyyy"
        );
        return {
          title: t(`${routeName}.${props?.title}`, {
            todayDate: today,
            tomorrowDate: tomorrow,
          }),
          description: t(`${routeName}.${props?.description}`),
        };
      }
      case BODY_TYPES.PING_PONG_ICONS: {
        const providerId = provider
          ? provider?.providerId
          : getSessionStorage(STORAGE_KEYS.PROVIDER_DATA)?.providerId;
        return {
          providerId: providerId || "",
          loading: isLogoLoader,
        };
      }
      case BODY_TYPES.FILE_UPLOAD_CARD: {
        return {
          onClickTryAgain: handleFileUpload,
          onAllRequiredUploaded: handleAllRequiredUploaded,
          fileKey: props.fileKey || "default",
        };
      }
      case BODY_TYPES.CURRENT_LINKED_BANK_CARD: {
        const parseData = props?.cardData ? JSON.parse(props?.cardData) : [];
        return {
          heading: t(`${routeName}.${props?.heading}`),
          description: t(`${routeName}.${props?.description}`, {
            linkedBank: parseData.length,
          }),
          data: parseData,
        };
      }
      case BODY_TYPES.PAYMENT_SCHEDULE_CARD: {
        return {
          heading: t(`${routeName}.${props?.heading}`),
          seeAll: t(`${routeName}.${props?.seeAll}`),
          onSeeAll: () => {
            if (props?.showPaymentPlanModal) {
              setPayments(props?.cardData);
              setShowPaymentPlanModal(true);
              return;
            }
            navigateWithQuery(`/${ROUTES.REPAYMENT_SCHEDULE}`, {
              state: { payments },
            });
          },
          payments: props?.cardData,
        };
      }
      case BODY_TYPES.DOCUMENT_UPLOAD_CARD: {
        const documents = props?.documents ? JSON.parse(props?.documents) : [];
        const groupId = props.fileKey || `document-group-${index}`;

        // Check if this group has any required documents
        const hasRequiredDocuments = documents.some((doc) => doc.isRequired);

        return {
          heading: t(`${routeName}.${props?.heading}`),
          documents: documents,
          handleFileUpload: handleFileUpload,
          onAllRequiredUploaded: (status) => {
            if (hasRequiredDocuments) {
              updateUploadGroupStatus(groupId, status);
            }
          },
          fileUploadStatus: fileUploadStatus,
          fileKey: groupId,
          documentList: documentList,
          onDeleteDocument: handleDeleteDocument,
          isLoadingDocuments: isLoadingDocuments,
        };
      }
      case BODY_TYPES.DOCUMENT_GROUP_UPLOAD_CARD: {
        return {
          handleFileUpload: handleFileUpload,
          onAllRequiredUploaded: (groupId, status) => {
            updateUploadGroupStatus(groupId, status);
          },
          fileUploadStatus: fileUploadStatus,
          onClickAddBank: () => setShowSelectBankModal(true),
          documentList: documentList,
          onDeleteDocument: handleDeleteDocument,
        };
      }
      case BODY_TYPES.TAB_BAR: {
        const parseData = props?.tabData && JSON.parse(props?.tabData);
        const tabId = `tab-group-${index}`;
        const hasRequiredInTabs = parseData?.value?.some((tab) => {
          if (tab.tabType === "document") {
            const documentCount = Number(tab.documentCount) || 0;
            return documentCount > 0 || tab.tabData?.[0]?.isRequired;
          }
          return false;
        });

        return {
          activeTabIndex: activeTabIndex,
          onClickTab: setActiveTabIndex,
          tabData: parseData?.value,
          handleFileUpload: handleFileUpload,
          onAllRequiredUploaded: (status) => {
            if (hasRequiredInTabs) {
              updateUploadGroupStatus(tabId, status);
            }
          },
          fileUploadStatus: fileUploadStatus,
          documentList: documentList,
          onDeleteDocument: handleDeleteDocument,
          isLoadingDocuments: isLoadingDocuments,
        };
      }
      case BODY_TYPES.REQUIRED_LIST_DOCUMENT_CARD: {
        const documentList = props?.documentList
          ? JSON.parse(props?.documentList)
          : [];
        return {
          documentList: documentList,
        };
      }
      case BODY_TYPES.DOWNLOAD_DOCUMENT_CARD: {
        const documentList = props?.documents
          ? JSON.parse(props?.documents)
          : [];
        return {
          documentList: documentList,
        };
      }
      case BODY_TYPES.SELECTED_BANK_BADGE: {
        const linkedBanks = props?.cardData ? JSON.parse(props?.cardData) : [];

        return {
          connectedBank: linkedBanks[linkedBanks.length - 1],
        };
      }
      case BODY_TYPES.SELECTABLE_ITEM_CARD: {
        const data = props?.data ? JSON.parse(props?.data) : [];
        return {
          data: data.length && data[0],
        };
      }
      case BODY_TYPES.INFO_KEY_VALUE_CARD: {
        return {
          data: props.isCustomData ? mapAssetsGrouped(props.data) : props.data,
        };
      }
      case BODY_TYPES.NOTICE_CARD: {
        const {
          days,
          hours,
          bgColor,
          icon,
          i18nHeadingKey,
          i18nDescriptionKey,
          formattedExpiry,
        } = getExpiryStatus(props?.expiryDate);
        return {
          ...props,
          backgroundColor: props?.isStatic ? props.backgroundColor : bgColor,
          icon: props?.isStatic ? props?.icon : icon,
          headingText:
            props?.isStatic && props.heading
              ? t(`${routeName}.${props.heading}`)
              : i18nHeadingKey,
          headingValues: props?.isStatic ? {} : { days, hours },
          descriptionText:
            props?.isStatic && props.description
              ? t(`${routeName}.${props.description}`)
              : i18nDescriptionKey,
          descriptionValues: props?.isStatic
            ? {}
            : { expiryDate: formattedExpiry },
        };
      }
      case BODY_TYPES.AVAILABLE_ASSETS_CARD: {
        return {
          onClickButton: () => {
            searchParams.delete("status");
            searchParams.delete("intentId");
            setSearchParams(searchParams);
            handleBackPress();
            return;
          },
        };
      }
      case BODY_TYPES.RADIO_GROUP: {
        const { key, initialValue } = props || {};
        if (!(key in formState) && initialValue) {
          setFormState((prevState) => ({
            ...prevState,
            [key]: initialValue ? initialValue : null,
          }));
        }
        return {
          value: formState[key],
          onChange: (value) => {
            setFormState((prevState) => ({ ...prevState, [key]: value }));
          },
        };
      }
      case BODY_TYPES.EDIT_OPTION_CARD: {
        const data = props?.data?.map((item) => ({
          ...item,
          value: formState[item.key] || item.value,
        }));

        return {
          data: data,
          onChange: (key, value) => {
            setFormState((prevState) => ({ ...prevState, [key]: value }));
          },
        };
      }

      // Footer Types
      case FOOTER_TYPES.DEFAULT_BUTTON: {
        let showButton = true;
        let providerName = provider
          ? provider?.displayName
          : getSessionStorage(STORAGE_KEYS.PROVIDER_DATA)?.displayName;
        if (selectedLanguage.value === "ar") {
          providerName = provider
            ? provider?.arabicDisplayName
            : getSessionStorage(STORAGE_KEYS.PROVIDER_DATA)?.arabicDisplayName;
        }

        // Check if any file is uploaded for upload_document action
        if (
          (props.action === "upload_document" ||
            props.action === "delete_my_application") &&
          Object.values(fileUploadStatus).some(
            (status) => status !== FILE_UPLOAD_STATUS.NOT_STARTED
          )
        ) {
          showButton = false;
        }

        // IMPORTANT: Disable button if not all required documents are uploaded
        if (props.action === "upload_document_next" && !allRequiredUploaded) {
          showButton = false;
        }

        let variables = {};
        if (props?.isEditMyRevenue) {
          variables.in_edit_my_revenue = true;
        }

        return {
          onClick: (action) => {
            let buttonType = props?.buttonType ? props?.buttonType : "default";
            setButtonType(buttonType);
            const currentPageNotNeedsToComplete = [
              "stp-pos-finance-link-bank-account",
              "fleet-finance-link-bank-account",
            ];

            if (action === "show_document_list") {
              setShowDocumentListModal(true);
              return;
            }

            if (props?.showBackConfirm) {
              setBackNavigateTo(props?.navigateTo);
              setShowBackConfirm(true);
            } else {
              if (props?.navigateToBack) {
                searchParams.delete("status");
                searchParams.delete("intentId");
                setSearchParams(searchParams);
                handleBackPress();
                return;
              }
              if (
                currentPageNotNeedsToComplete.includes(
                  financeJourney?.page?.slug
                ) &&
                (!intentId || status === "FAILED")
              ) {
                window.location.href = bankUrl;
                return;
              } else {
                if (props?.buttonType === "check_eligibility") {
                  searchParams.delete("status");
                  searchParams.delete("intentId");
                  setSearchParams(searchParams);
                  financeJourney?.meta?.task?.id && handleNextPress(action);
                } else {
                  financeJourney?.meta?.task?.id &&
                    handleNextPress(action, variables);
                }
              }
            }
          },
          onClickFileUpload: handleFileUpload,
          disabled:
            (isLoading && !!isButtonLoader) ||
            props?.expiresIn > 0 ||
            (!allRequiredUploaded &&
              financeJourney?.page?.slug === "fleet-finance-upload-document") || // This is key - button disabled if not all required uploaded
            handleDefaultBtnDisabled(props?.action),
          containerCheckbox: "check-box-container-class",
          checkboxValue: liabilityCheck,
          onChangeCheckBox: () => setLiabilityCheck((prevState) => !prevState),
          isCheckBoxVisible: props?.isCheckBox,
          checkboxLabel: t(`${routeName}.${props?.checkBoxLabel}`),
          providerName: props?.showProviderName ? providerName : "",
          isLogoLoader:
            (isLogoLoader && props?.buttonType === buttonType) ||
            (isButtonLoader && isLoading && props?.buttonType === buttonType),
          buttonClassName:
            isLogoLoader && handleDefaultBtnDisabled(props?.action)
              ? "logo-loader-button-disabled"
              : "",
          showButton: showButton,
        };
      }
      case FOOTER_TYPES.MEAT_BALLS_LOADER:
        return { loadingText: t(`${routeName}.${props?.loadingText}`) };
      case FOOTER_TYPES.RESEND_OTP:
        return { showCountdownTimer, setShowCountdownTimer };
      case FOOTER_TYPES.ACCEPT_OUR_TC: {
        return {
          acceptText: t(`${routeName}.${props?.acceptText}`, {
            tenant: tenantConfig?.name,
          }),
          termsAndConditionText: t(
            `${routeName}.${props?.termsAndConditionText}`
          ),
          acceptEndText: t(`${routeName}.${props?.acceptEndText}`),
          value: isTCAccepted,
          onChange: () => handleIsTCAccepted(!isTCAccepted),
          onClickFooterLink: () => {
            if (props?.isModalView) {
              setTermsAndPrivacyData(
                props?.termsConditionsContent
                  ? props.termsConditionsContent
                  : tenantConfig.terms_conditions
              );
              setShowTermsAndPrivacyModal(true);
              return;
            }
            navigateWithQuery(`/${ROUTES.TERMS_AND_CONDITIONS}`, {
              state: { showButton: true },
            });
          },
          privacyText: t(`${routeName}.${props?.privacyText}`),
          onClickPrivacyFooterLink: () => {
            if (props?.isModalView) {
              setTermsAndPrivacyData(
                props?.privacyPolicyContent
                  ? props.privacyPolicyContent
                  : tenantConfig.privacy_policy
              );
              setShowTermsAndPrivacyModal(true);
              return;
            }
            navigateWithQuery(`/${ROUTES.PRIVACY_POLICY}`, {
              state: { showButton: true },
            });
          },
        };
      }
      case FOOTER_TYPES.LINK_TEXT: {
        return {
          onClick: () => {
            if (props?.action === LINK_TEXT_ACTION.NAVIGATE_TO) {
              if (props?.navigateTo === "remind_me_later_popup") {
                console.log("remind_me_later");
                setShowRemindMeLater(true);
              }
            }
          },
        };
      }
      case FOOTER_TYPES.ICON_TEXT:
        let parseData;
        if (props?.link) parseData = JSON.parse(props?.link);
        return {
          text: t(`${routeName}.${props?.text}`),
          iconLabelTextClass: props?.icon ? "icon-label-text" : "label-text",
          className: props?.icon ? "icon-label-container" : "icon-container",
          link: parseData?.value,
        };
      case FOOTER_TYPES.CHECK_BOX_PERMISSION:
        return {
          label: t(`${routeName}.${props?.label}`),
          containerClassName: "check-box-container-class",
          value: liabilityCheck,
          onChange: () => setLiabilityCheck((prevState) => !prevState),
        };
      case FOOTER_TYPES.POWERED_BY: {
        return {
          type: FOOTER_TYPES.POWERED_BY,
          poweredByText: t(`${routeName}.${props?.title}`),
          footerText: props?.footerText
            ? t(`${routeName}.${props?.footerText}`)
            : null,
        };
      }

      default:
        return {};
    }
  };
  useEffect(() => {
    // Reset tracking when finance journey changes
    uploadGroupStatusRef.current.clear();
    setAllRequiredUploaded(false);
  }, [financeJourney?.page?.id]);
  useEffect(() => {
    if (tenantConfig?.phone_number_policy?.content.allowed_countries.length) {
      const allowedCountries =
        tenantConfig?.phone_number_policy?.content.allowed_countries;
      setSelectedCountry(allowedCountries[0]);
    }
  }, [tenantConfig?.phone_number_policy]);

  useEffect(() => {
    handleEligibilityData(eligibilityPolicy);
  }, [eligibilityPolicy]);

  useEffect(() => {
    if (
      formState?.downpayment_amount ||
      formState?.loan_amount ||
      (formState.downpayment_percent &&
        formState.leasing_amount &&
        product !== "fleet-financing-beta")
    ) {
      calculateInstallment();
    } else {
      calculateStraightLineInstallment();
    }
  }, [formState]);

  useEffect(() => {
    if (formState?.code?.length === 4) {
      const inputs = document.querySelectorAll("input");
      inputs.forEach((input) => input.blur());
      handleNextPress();
    }
  }, [formState?.code]);

  useEffect(() => {
    handleNextJourney({
      hasLoader:
        (financeJourney?.page?.slug === "auto-finance-link-bank-account" &&
          status) ||
        ((financeJourney?.page?.slug === "stp-pos-finance-link-bank-account" ||
          financeJourney?.page?.slug === "fleet-finance-link-bank-account") &&
          status &&
          status !== "FAILED") ||
        !financeJourney?.page?.slug
          ? true
          : false,
      autoComplete: autoComplete,
      status: status,
    });
    const intervalId = setInterval(() => {
      handleNextJourney({
        hasLoader: false,
        autoComplete: autoComplete,
        status: status,
      });
    }, [5000]);
    if (
      financeJourneyStatus?.processing_status === "COMPLETED" &&
      financeJourneyStatus?.status === "COMPLETED" &&
      financeJourneyStatus?.application_id
    ) {
      setIsLoading(false);
      navigateWithQuery(`/${ROUTES.FINANCE_DETAIL}`, {
        state: {
          financeApplicationId: financeJourneyStatus?.application_id,
        },
      });
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [
    financeJourneyStatus,
    intentId,
    autoComplete,
    status,
    financeJourney?.page?.slug,
  ]);

  useEffect(() => {
    const isExpired = connectAuth?.accessToke
      ? isTokenExpired(connectAuth?.accessToken)
      : false;
    const needsAuthPages = [
      "auto-finance-request-submitted",
      "auto-finance-select-bank",
      "auto-finance-track-request",
      "stp-pos-finance-select-bank",
      "fleet-finance-select-bank",
      // "fleet-finance-upload-bank-statement",
    ];

    const currentPageNeedsAuth = needsAuthPages.includes(
      financeJourney?.page?.slug
    );
    if (
      !connectAuth?.accessToken &&
      !connectAuth?.base_url &&
      currentPageNeedsAuth
    ) {
      handleAuthConnect();
    }
    if (isExpired) {
      handleAuthConnect();
    } else if (
      !providers.length &&
      connectAuth?.accessToken &&
      connectAuth?.base_url
    ) {
      handleGetProviders();
    } else if (provider?.providerId) {
      handleCreateIntent();
    }
  }, [
    connectAuth?.accessToken,
    connectAuth?.base_url,
    financeJourney?.page?.id,
    provider?.providerId,
  ]);

  useEffect(() => {
    if (financeJourney) {
      if (
        intentId &&
        autoComplete &&
        (financeJourney.page.slug === "auto-finance-link-bank-account" ||
          financeJourney.page.slug === "stp-pos-finance-link-bank-account" ||
          financeJourney.page.slug === "fleet-finance-link-bank-account")
      ) {
        handleNextPress();
        setAutoComplete(false);
      }
      if (
        financeJourney.page.slug === "stp-pos-finance-bank-connected" ||
        financeJourney?.page?.slug === "fleet-finance-bank-connected"
      ) {
        setIsLogoLoader(false);
      }
    }
  }, [financeJourney?.page?.id]);

  useEffect(() => {
    if (
      ((!financeJourney?.page?.content?.components || status || intentId) &&
        financeJourney?.page?.slug !== "stp-pos-finance-bank-connected") ||
      financeJourney?.page?.slug !== "fleet-finance-bank-connected"
    )
      return;

    const isLinkBankPage =
      financeJourney?.page?.slug === "auto-finance-link-bank-account" ||
      financeJourney?.page?.slug === "stp-pos-finance-link-bank-account" ||
      financeJourney.page.slug === "fleet-finance-link-bank-account";
    const isButtonAction = findButton(
      financeJourney?.page?.content?.components
    );

    if (setIsButtonLoader && !isLogoLoader && !isLoading) {
      setIsButtonLoader(!!isButtonAction);
    }

    if (!isLinkBankPage) return;

    const url = findUrlAttribute(financeJourney?.page?.content?.components);
    if ((bankUrl || url?.value) && isLogoLoader) {
      window.location.href = bankUrl ? bankUrl : url.value;
    }
  }, [financeJourney, isLogoLoader]);

  useEffect(() => {
    getUserDetails();
    handleFinanceJourneyStatus();
  }, []);

  const findButton = (templateSchema) => {
    const queue = [...templateSchema];
    while (queue.length) {
      const component = queue.shift();
      if (
        component?.attributes?.type === "default_button" ||
        component?.attributes?.type === "connect_bank_card"
      ) {
        return true;
      }
      if (Array.isArray(component?.components)) {
        queue.push(...component.components);
      }
    }
    return null;
  };

  return (
    <>
      {/* financeJourney?.page?.content */}
      {financeJourney?.page?.content ? (
        <AnimatedSlider
          direction={direction}
          keyIndex={activeIndex}
          axis={handleAnimationAxis(financeJourney?.page?.slug)}
        >
          <div id="company-details-container">
            {templateSchema(financeJourney?.page?.content).map(
              (element, index) => {
                const Component = element.Component;
                const props = element.props;
                const customProps = getCustomProps(props, index);
                return Component
                  ? React.createElement(Component, {
                      key: index,
                      ...element.props,
                      ...customProps,
                    })
                  : null;
              }
            )}
          </div>
        </AnimatedSlider>
      ) : null}
      <BottomContentModal
        visible={isHowItWorkVisible}
        onClickFilter={() => {
          setIsHowItWorkVisible(false);
        }}
        onClickBackdrop={() => {
          setIsHowItWorkVisible(false);
        }}
      />
      <CustomLoader
        visible={isLoading && !isButtonLoader}
        providerId={provider?.providerId}
        isPingPongLoader={
          intentId &&
          (financeJourney?.page?.slug === "stp-pos-finance-link-bank-account" ||
            financeJourney?.page?.slug === "fleet-finance-link-bank-account") &&
          status === "SUCCESSFUL"
        }
      />
      <BackButtonConfirmation
        show={showBackConfirm}
        onClickCancel={() => {
          setShowBackConfirm(false);
          setBackNavigateTo("");
        }}
        onClickConfirm={() => onClickBackConfirm()}
      />
      <ConfirmationPopup
        show={showRejectionPopup}
        icon={RedExclamationCircle}
        heading="rejection_popup.heading"
        description="rejection_popup.description"
        cancelButtonText="rejection_popup.cancel"
        onClickCancel={() => setShowRejectionPopup(false)}
        confirmButtonText="rejection_popup.try_again"
        onClickConfirm={() => {
          const currentPageNotNeedsToComplete = [
            "stp-pos-finance-link-bank-account",
            "fleet-finance-link-bank-account",
          ];

          setShowRejectionPopup(false);
          if (
            currentPageNotNeedsToComplete.includes(financeJourney?.page?.slug)
          ) {
            window.location.href = bankUrl;
          } else {
            handleNextPress();
          }
        }}
      />
      <DocumentListModal
        visible={showDocumentListModal}
        onClickClose={() => setShowDocumentListModal(false)}
        documents={FLEET_FINANCE_REQUIRED_DOCUMENTS}
      />
      <PaymentPlanModal
        visible={showPaymentPlanModal}
        onClickClose={() => setShowPaymentPlanModal(false)}
        payments={payments}
      />
      <TermsAndPrivacyModal
        visible={showTermsAndPrivacyModal}
        onClickClose={() => setShowTermsAndPrivacyModal(false)}
        data={termsAndPrivacyData}
      />
      <SelectBankModal
        visible={showSelectBankModal}
        onClickBackdrop={() => setShowSelectBankModal(false)}
      />
      <RemindMeLaterPopup
        visible={showRemindMeLater}
        handleDone={() => {
          handleNextPress(null, { remind_me_later: true });
        }}
      />
    </>
  );
};

export default CompanyDetatils;
